"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.RemoteMediaGroup = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _lodash = require("lodash");
var _loggerProxy = _interopRequireDefault(require("../common/logs/logger-proxy"));
var _remoteMedia = require("./remoteMedia");
/* eslint-disable valid-jsdoc */
/* eslint-disable require-jsdoc */
/* eslint-disable import/prefer-default-export */
var RemoteMediaGroup = exports.RemoteMediaGroup = /*#__PURE__*/function () {
  function RemoteMediaGroup(mediaRequestManager, receiveSlots, priority, commitMediaRequest) {
    var _this = this;
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    (0, _classCallCheck2.default)(this, RemoteMediaGroup);
    (0, _defineProperty2.default)(this, "mediaRequestManager", void 0);
    (0, _defineProperty2.default)(this, "priority", void 0);
    (0, _defineProperty2.default)(this, "options", void 0);
    (0, _defineProperty2.default)(this, "unpinnedRemoteMedia", void 0);
    (0, _defineProperty2.default)(this, "mediaRequestId", void 0);
    // id of the "active-speaker" media request id
    (0, _defineProperty2.default)(this, "pinnedRemoteMedia", void 0);
    this.mediaRequestManager = mediaRequestManager;
    this.priority = priority;
    this.options = options;
    this.unpinnedRemoteMedia = receiveSlots.map(function (slot) {
      return new _remoteMedia.RemoteMedia(slot, _this.mediaRequestManager, {
        resolution: _this.options.resolution
      });
    });
    this.pinnedRemoteMedia = [];
    this.sendActiveSpeakerMediaRequest(commitMediaRequest);
  }

  /**
   * Gets the array of remote media elements from the group
   *
   * @param {string} filter - 'all' (default) returns both pinned and unpinned
   * @returns {Array<RemoteMedia>}
   */
  (0, _createClass2.default)(RemoteMediaGroup, [{
    key: "getRemoteMedia",
    value: function getRemoteMedia() {
      var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'all';
      if (filter === 'unpinned') {
        // return a shallow copy so that the client cannot modify this.unpinnedRemoteMedia array
        return (0, _toConsumableArray2.default)(this.unpinnedRemoteMedia);
      }
      if (filter === 'pinned') {
        // return a shallow copy so that the client cannot modify this.pinnedRemoteMedia array
        return (0, _toConsumableArray2.default)(this.pinnedRemoteMedia);
      }
      return [].concat((0, _toConsumableArray2.default)(this.unpinnedRemoteMedia), (0, _toConsumableArray2.default)(this.pinnedRemoteMedia));
    }

    /**
     * Sets CSIs for multiple RemoteMedia instances belonging to this RemoteMediaGroup.
     * For each entry in the remoteMediaCsis array:
     * - if csi is specified, the RemoteMedia instance is pinned to that CSI
     * - if csi is undefined, the RemoteMedia instance is unpinned
     * @internal
     */
  }, {
    key: "setActiveSpeakerCsis",
    value: function setActiveSpeakerCsis(remoteMediaCsis) {
      var _this2 = this;
      var commit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      (0, _lodash.forEach)(remoteMediaCsis, function (_ref) {
        var csi = _ref.csi,
          remoteMedia = _ref.remoteMedia;
        if (csi) {
          if (!(_this2.pinnedRemoteMedia.indexOf(remoteMedia) >= 0)) {
            var unpinId = _this2.unpinnedRemoteMedia.indexOf(remoteMedia);
            if (unpinId >= 0) {
              _this2.unpinnedRemoteMedia.splice(unpinId, 1);
              _this2.pinnedRemoteMedia.push(remoteMedia);
            } else {
              throw new Error("failed to pin a remote media object ".concat(remoteMedia.id, ", because it is not found in this remote media group"));
            }
          }
          remoteMedia.sendMediaRequest(csi, false);
        } else {
          if (!(_this2.unpinnedRemoteMedia.indexOf(remoteMedia) >= 0)) {
            var pinId = _this2.pinnedRemoteMedia.indexOf(remoteMedia);
            if (pinId >= 0) {
              _this2.pinnedRemoteMedia.splice(pinId, 1);
              _this2.unpinnedRemoteMedia.push(remoteMedia);
            } else {
              throw new Error("failed to unpin a remote media object ".concat(remoteMedia.id, ", because it is not found in this remote media group"));
            }
          }
          remoteMedia.cancelMediaRequest(false);
        }
      });
      this.cancelActiveSpeakerMediaRequest(false);
      this.sendActiveSpeakerMediaRequest(false);
      if (commit) {
        this.mediaRequestManager.commit();
      }
    }

    /**
     * Pins a specific remote media instance to a specfic CSI, so the media will
     * no longer come from active speaker, but from that CSI.
     * If no CSI is given, the current CSI value is used.
     *
     */
  }, {
    key: "pin",
    value: function pin(remoteMedia, csi) {
      // if csi is not specified, use the current one
      var targetCsi = csi || remoteMedia.csi;
      if (!targetCsi) {
        throw new Error("failed to pin a remote media object ".concat(remoteMedia.id, ", because it has no CSI set and no CSI value was given"));
      }
      if (this.pinnedRemoteMedia.indexOf(remoteMedia) >= 0) {
        if (targetCsi === remoteMedia.csi) {
          // remote media already pinned to target CSI, nothing to do
          _loggerProxy.default.logger.log("RemoteMediaGroup#pin --> remote media ".concat(remoteMedia.id, " already pinned"));
          return;
        }
      } else {
        var idx = this.unpinnedRemoteMedia.indexOf(remoteMedia);
        if (idx < 0) {
          throw new Error("failed to pin a remote media object ".concat(remoteMedia.id, ", because it is not found in this remote media group"));
        }
        this.unpinnedRemoteMedia.splice(idx, 1);
        this.pinnedRemoteMedia.push(remoteMedia);
        this.cancelActiveSpeakerMediaRequest(false);
        this.sendActiveSpeakerMediaRequest(false);
      }
      remoteMedia.sendMediaRequest(targetCsi, false);
      this.mediaRequestManager.commit();
    }

    /**
     * Unpins a remote media instance, so that it will again provide media from active speakers
     *
     */
  }, {
    key: "unpin",
    value: function unpin(remoteMedia) {
      if (this.unpinnedRemoteMedia.indexOf(remoteMedia) >= 0) {
        _loggerProxy.default.logger.log("RemoteMediaGroup#pin --> remote media ".concat(remoteMedia.id, " already unpinned"));
        return;
      }
      var idx = this.pinnedRemoteMedia.indexOf(remoteMedia);
      if (idx < 0) {
        throw new Error("failed to unpin a remote media object ".concat(remoteMedia.id, ", because it is not found in this remote media group"));
      }
      this.pinnedRemoteMedia.splice(idx, 1);
      this.unpinnedRemoteMedia.push(remoteMedia);
      remoteMedia.cancelMediaRequest(false);
      this.cancelActiveSpeakerMediaRequest(false);
      this.sendActiveSpeakerMediaRequest(false);
      this.mediaRequestManager.commit();
    }
  }, {
    key: "isPinned",
    value: function isPinned(remoteMedia) {
      if (this.unpinnedRemoteMedia.indexOf(remoteMedia) >= 0) {
        return false;
      }
      if (this.pinnedRemoteMedia.indexOf(remoteMedia) >= 0) {
        return true;
      }
      throw new Error("remote media object ".concat(remoteMedia.id, " not found in the group"));
    }

    /**
     * setPreferLiveVideo - sets preferLiveVideo to true/false
     * @internal
     */
  }, {
    key: "setPreferLiveVideo",
    value: function setPreferLiveVideo(preferLiveVideo, commit) {
      if (this.options.preferLiveVideo !== preferLiveVideo) {
        this.options.preferLiveVideo = preferLiveVideo;
        this.sendActiveSpeakerMediaRequest(commit);
      }
    }
  }, {
    key: "sendActiveSpeakerMediaRequest",
    value: function sendActiveSpeakerMediaRequest(commit) {
      var _this$options, _this$options$namedMe, _this$options2;
      this.cancelActiveSpeakerMediaRequest(false);
      this.mediaRequestId = this.mediaRequestManager.addRequest({
        policyInfo: {
          policy: 'active-speaker',
          priority: this.priority,
          crossPriorityDuplication: false,
          crossPolicyDuplication: false,
          preferLiveVideo: !!((_this$options = this.options) !== null && _this$options !== void 0 && _this$options.preferLiveVideo),
          namedMediaGroups: (_this$options$namedMe = this.options.namedMediaGroup) !== null && _this$options$namedMe !== void 0 && _this$options$namedMe.value ? [(_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2.namedMediaGroup] : undefined
        },
        receiveSlots: this.unpinnedRemoteMedia.map(function (remoteMedia) {
          return remoteMedia.getUnderlyingReceiveSlot();
        }),
        codecInfo: this.options.resolution && {
          codec: 'h264',
          maxFs: (0, _remoteMedia.getMaxFs)(this.options.resolution)
        }
      }, commit);
    }
  }, {
    key: "cancelActiveSpeakerMediaRequest",
    value: function cancelActiveSpeakerMediaRequest(commit) {
      if (this.mediaRequestId) {
        this.mediaRequestManager.cancelRequest(this.mediaRequestId, commit);
        this.mediaRequestId = undefined;
      }
    }

    /**
     * setNamedMediaGroup - sets named media group type and value
     * @internal
     */
  }, {
    key: "setNamedMediaGroup",
    value: function setNamedMediaGroup(namedMediaGroup, commit) {
      if (this.options.namedMediaGroup.value !== namedMediaGroup.value || this.options.namedMediaGroup.type !== namedMediaGroup.type) {
        this.options.namedMediaGroup = namedMediaGroup;
        this.sendActiveSpeakerMediaRequest(commit);
      }
    }

    /**
     * Invalidates the remote media group by clearing the references to the receive slots
     * used by all remote media from that group and cancelling all media requests.
     * After this call the remote media group is unusable.
     *
     * @param{boolean} commit whether to commit the cancellation of media requests
     * @internal
     */
  }, {
    key: "stop",
    value: function stop() {
      var commit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.unpinnedRemoteMedia.forEach(function (remoteMedia) {
        return remoteMedia.stop(false);
      });
      this.pinnedRemoteMedia.forEach(function (remoteMedia) {
        return remoteMedia.stop(false);
      });
      this.cancelActiveSpeakerMediaRequest(false);
      if (commit) {
        this.mediaRequestManager.commit();
      }
    }

    /**
     * Checks if a given RemoteMedia instance belongs to this group.
     *
     * @param remoteMedia RemoteMedia instance to check
     * @param filter controls which remote media from the group to check
     * @returns true if remote media is found
     */
  }, {
    key: "includes",
    value: function includes(remoteMedia) {
      var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';
      if (filter === 'pinned') {
        return this.pinnedRemoteMedia.includes(remoteMedia);
      }
      if (filter === 'unpinned') {
        return this.unpinnedRemoteMedia.includes(remoteMedia);
      }
      return this.unpinnedRemoteMedia.includes(remoteMedia) || this.pinnedRemoteMedia.includes(remoteMedia);
    }
  }]);
  return RemoteMediaGroup;
}();
//# sourceMappingURL=remoteMediaGroup.js.map
